import React, { useState, useRef } from "react";
import { Autocomplete, SortMenu } from "@ann/web-components";
import {
  FiltersContainer,
  FiltersLeftContent,
  FiltersRightContent,
} from "./Filters.styled";

const Filters = ({
  onSortChange,
  onOrderChange,
  selectedSortOption = "createdAt",
  orderDirection = "desc",
  onSearchChange,
  loading = false,
}) => {
  const [autocompleteValue, setAutocompleteValue] = useState("");
  const [autocompleteKey, setAutocompleteKey] = useState(0);
  const autocompleteRef = useRef(null);

  const handleSearchChange = (value) => {
    setAutocompleteValue(value);
    onSearchChange?.(value);
  };

  const handleSearchClear = () => {
    setAutocompleteValue("");
    setAutocompleteKey((prev) => prev + 1);

    if (autocompleteRef.current) {
      const input = autocompleteRef.current.querySelector("input");
      if (input) {
        input.value = "";
        input.dispatchEvent(new Event("input", { bubbles: true }));
      }
    }
    
    onSearchChange?.("");
  };

  return (
    <FiltersContainer>
      <FiltersLeftContent>
        <Autocomplete
          key={autocompleteKey}
          ref={autocompleteRef}
          value={autocompleteValue}
          onChange={handleSearchChange}
          onSearch={() => {}}
          onSuggestionSelect={() => {}}
          onClear={handleSearchClear}
          placeholder="Search"
          disabled={loading}
          suggestions={[]}
        />
      </FiltersLeftContent>

      <FiltersRightContent>
        <SortMenu
          minWidth="200px"
          onChange={(id) => {
            if (onSortChange) {
              onSortChange(id);
            }
          }}
          order={orderDirection ? orderDirection.toLowerCase() : "desc"}
          onOrderChange={(newOrder) => {
            if (onOrderChange) {
              onOrderChange(newOrder);
            }
          }}
          options={[
            {
              icon: 'clock',
              id: 'createdAt',
              label: 'Most Recent'
            },
            {
              icon: 'sortByAlpha',
              id: 'fullName',
              label: 'Name (A-Z)'
            },
            {
              icon: 'email',
              id: 'email',
              label: 'Email'
            },
            {
              icon: 'update',
              id: 'updatedAt',
              label: 'Last Updated'
            }
          ]}
          selected={selectedSortOption || "createdAt"}
          size="medium"
          title="SORT BY"
          width="240px"
          disabled={loading}
        />
      </FiltersRightContent>
    </FiltersContainer>
  );
};

export default Filters;

